import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import cloudImage from 'Assets/img/cloud-upload.svg';
import InformationIcon from 'Components/icons/information-icon';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import LinkInlineButton from 'Components/Button/LinkInlineButton';
import './UploadDocuments.scss';
import { uploadDocument, deleteDocument } from 'Apis/imageMatcherApi';
import { uploadDocumentFiletype } from 'Apis/caseDataAPI.js';
import FailedFiles from '../FailedFiles/FailedFiles.jsx';
import ResponseBanner from 'Components/cards/ResponseBanner';
import PassFiles from '../PassFiles/PassFiles.jsx';
import counterpart from 'counterpart';
import ImagePortal from 'Containers/ImagePortal';
export class UploadDocuments extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedFile: null,
      failedFile: [],
      passFile: [],
      intervalIds: [],
      isError: false,
      errorDescription: '',
      fileCount: 0,
      documentFiletypeList: [],
    };

    this.attachBindings();
  }

  attachBindings() {
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleFileSelect = this.handleFileSelect.bind(this);
    this.increaseProgressBarStatus = this.increaseProgressBarStatus.bind(this);
    this.validateFileType = this.validateFileType.bind(this);
    this.validateFileSize = this.validateFileSize.bind(this);
    this.isDocumentAlreadyUploaded = this.isDocumentAlreadyUploaded.bind(this);
    this.displayFileList = this.displayFileList.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
    this.showErrorBanner = this.showErrorBanner.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.handleProgressBarStatus = this.handleProgressBarStatus.bind(this);
    this.getFileName = this.getFileName.bind(this);
    this.displayFailFileList = this.displayFailFileList.bind(this);
    this.uploadDocumentFiletype = this.uploadDocumentFiletype.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);


  }

  componentWillMount() {
    this.uploadDocumentFiletype();
    this.setState({
      passFile: this.props.uploadFileList
    });
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps.uploadFileList) !== JSON.stringify(this.props.uploadFileList)) {
      this.setState({
        passFile: nextProps.uploadFileList
      });
    }
  }

  getFileName(fileName, fileLengthLimit) {
    let newFileName = fileName.length > fileLengthLimit ? fileName.substring(0, fileLengthLimit).concat('...') : fileName;
    return newFileName;
  }

  get dragAndDropLabelAndBrowseButtonBlock() {
    return (
      <div className="input-cover">
        <div><span className="drag-drop-file-label">{counterpart('globalTranslate.takeAction.dragAndDrop')}&nbsp;</span>
          <span><LinkInlineButton
            action={this.selectFile}
            extraClass="file-upload-browse"
          >{counterpart('globalTranslate.takeAction.browseComputer')}</LinkInlineButton>
          </span>
        </div>
        {<div className="allow-file-type">
          {counterpart('globalTranslate.takeAction.fileType')}
        </div>
        }
      </div>
    );
  }

  selectFile = () => {
    this.input.click();
  };


  closeBanner() {
    this.setState({
      isError: false
    });
  }


  showErrorBanner() {

    if (this.state.isError) {
      return (
        <div>
        <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title={counterpart('globalTranslate.takeAction.errorOccurred')}
            description={this.state.errorDescription}
            type="danger"
            onClose={this.closeBanner}
            cancelButtonText={counterpart('globalTranslate.takeAction.dismiss')}
            primaryButtonActionValue=""
            primaryButtonText="OKAY"
            primaryButtonAction={this.closeBanner}
          />
          </ImagePortal>
        </div>
      );
    }

  }

  get fileUploadInitialBlock() {
    const fileDragClass = classnames('file-drag', {
      hover: this.state.hoverState,
    });
    return (
      <div
        className={fileDragClass}
        onDragOver={this.handleDragOver}
        onDragLeave={this.handleDragOver}
        onDrop={this.handleFileSelect}
      >
        <input
          type="file"
          tabIndex="-1"
          ref={(x) => this.input = x}
          className="input"
          name="sample-test"
          multiple={true}
          onChange={this.handleFileSelect}
        />
        {<img src={cloudImage} alt="icon" className="uploadImg" />}
        {this.dragAndDropLabelAndBrowseButtonBlock}
      </div>);
  }

  get tooltipIconBlock() {
    return (
      <div className="information-icon-file-upload">
        <InformationBubble
          tooltipContent="Upload your spreadsheet containing your notices and merchant IDs. Max file name length 80 characters."
          extraClass="information-icon-file-upload"
        ><InformationIcon navIcon />
        </InformationBubble>
      </div>
    );
  }

  handleDragOver(e) {
    if ('preventDefault' in e) {
      e.stopPropagation();
      e.preventDefault();
    }
    const hoverState = e.type === 'dragover' ? 'hover' : null;
    this.setState({
      hoverState
    });
  }



  handleFileSelect = (e) => {
    this.handleDragOver(e);
    const files = (e.target.files && Array.from(e.target.files)) ||
                (e.dataTransfer.files && Array.from(e.dataTransfer.files)) ||
                [];
    let failedFiles = [];
    let passFiles = [...this.state.passFile];
    let passObject = '';
    let count = this.state.fileCount;

    let totalFiles = files.length + this.state.passFile.length;
    if (totalFiles > 5) {
      this.setState(
        {
          isError: true,
          errorDescription: 'Not allow to upload more than 5 files at a time'
        }
      )
    } else {
      files && files.forEach(newfile => {
        let validationTypeResult = this.validateFileType(newfile);
        let validationSizeResult = this.validateFileSize(newfile);
        let validateIfAlreadyUploaded = this.isDocumentAlreadyUploaded(newfile);
        if (validationTypeResult.status === true && validationSizeResult.status === true && validateIfAlreadyUploaded == false) {
          count = count + 1;
          passObject = { file: newfile, status: 'PENDING', documentName: '', response: '' }

          passFiles.push(passObject);
          this.setState({
            passFile: passFiles,
            fileCount: count,
            failedFile: []
          }, () => {
            if (this.state.fileCount === 0) {
              this.props.fileUploaded(false, this.state.passFile);
            } else {
              this.props.fileUploaded(true, this.state.passFile);
            }
          }
          )

          this.props.updateNextButtonStatus(true);
          uploadDocument(newfile, this.props.acquirerCode)
            .then(res => {
              const ua = window.navigator.userAgent;
              const isIE = ua.indexOf('Trident/') || ua.indexOf('MSIE');
              let originalFileName = res.data.originalDocumentName;
              if (isIE > 0) {
                let fullFilePath = res.data.originalDocumentName.split("\\");
                originalFileName = fullFilePath[fullFilePath.length - 1];
              }

              this.handleProgressBarStatus(originalFileName);
              let elem = document.getElementById(newfile.name);
              elem.style.width = 100 + '%';
              passFiles = [... this.state.passFile];
              passFiles.map(files => {
                if (files.file.name === originalFileName) {
                  files.status = "SUCCESS";
                  files.response = res;
                  files.documentName = res.data.documentName;
                  files.isUploaded = true;
                }
              })
              this.setState({
                passFile: passFiles,
                fileCount: this.state.fileCount - 1
              }, () => {
                if (this.state.fileCount === 0) {
                  this.props.fileUploaded(false, this.state.passFile);
                } else {
                  this.props.fileUploaded(true, this.state.passFile);
                }
                this.props.isDisabledHandler(passFiles);
              }
              );
            }).catch((error) => {
              
              let fileName = this.getFileName(newfile.name, 55);
              let failedObject = { file: newfile, errorMsg: `Something went wrong for file ${fileName}` };
              failedFiles.push(failedObject);

              if (passFiles.length > 1) {
                let remainingFiles = passFiles.filter(files => {
                  return files.file.name !== newfile.name;
                })
                passFiles = remainingFiles;
                this.props.isDisabledHandler(passFiles);
              } else {
                passFiles.pop();
              }
              this.handleProgressBarStatus(newfile.name);
              this.setState({
                failedFile: failedFiles,
                passFile: passFiles,
                fileCount: this.state.fileCount - 1
              }, () => {
                if (this.state.fileCount === 0) {
                  this.props.fileUploaded(false, this.state.passFile);
                } else {
                  this.props.fileUploaded(true, this.state.passFile);
                }

              }
              )

              console.log('FAILURE!!', error.message);
            });

          this.increaseProgressBarStatus(newfile);


        }
        else {
          let failedObject = '';
          let fileNames = this.getFileName(newfile.name, 60);
          if (validateIfAlreadyUploaded === true) {
            this.setState(
              {
                isError: true,
                errorDescription: `Selected file ${fileNames} is already uploaded`
              }
            )
          }
          else if (validationTypeResult.status == false) {
            failedObject = { file: newfile, errorMsg: validationTypeResult.errorMsg }
            failedFiles.push(failedObject);
          } else {
            failedObject = { file: newfile, errorMsg: validationSizeResult.errorMsg }
            failedFiles.push(failedObject);
          }

          this.setState({
            failedFile: failedFiles
          })
        }

      }

      );

    }

    e.target.value = '';

  };

  uploadDocumentFiletype(){
    uploadDocumentFiletype()
    .then((apiResponse) => {
      this.setState({
        documentFiletypeList: apiResponse.data.filter(e=>e.id !== 15),
      });
    })
    .catch((error) => {
      this.setState({
        documentFiletypeList: [],
      });
    });
  }


  handleProgressBarStatus(originalFileName) {
    let fileObj = this.state.intervalIds.filter(files => {
      return files.filename === originalFileName;
    });
    let newintervalIds = this.state.intervalIds.filter(files => {
      return files.filename !== originalFileName;
    })
    this.setState(
      {
        intervalIds: newintervalIds
      }
    )
    clearInterval(fileObj[0].id);

  }


  validateFileType(file) {
    let failedObj = '';
    if (file.type === 'image/tiff' || file.type === 'application/pdf' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png') {
      failedObj = { status: true, errorMsg: '' };
      return failedObj;
    } else {
      let fileName = this.getFileName(file.name, 55);
      failedObj = { status: false, errorMsg: `${counterpart('globalTranslate.takeAction.fileName')} ${fileName} is not a valid file type` };
      return failedObj;
    }
  }

  validateFileSize(file) {
    let failedObj = '';
    if (file.size <= 10485760) {
      failedObj = { status: true, errorMsg: '' };
      return failedObj;
    } else {
      let fileName = this.getFileName(file.name, 60);
      failedObj = { status: false, errorMsg: `${counterpart('globalTranslate.takeAction.fileName')} ${fileName} size exceeds` };
      return failedObj;
    }
  }

  isDocumentAlreadyUploaded(file) {
    let doc = this.state.passFile.filter(docs => {
      return docs.file.name === file.name;
    })
    if (doc.length !== 0) {
      return true;
    } else {
      return false;
    }
  }


  increaseProgressBarStatus(file) {
    let width = 1;
    let id = setInterval(frame, 1000);

    let jsondata = { id: id, filename: file.name }

    this.state.intervalIds.push(jsondata);
    function frame() {

      let elem = document.getElementById(file.name);

      if (width >= 75) {
        clearInterval(id);
      } else {
        width++;
        if (elem !== null) {
          elem.style.width = width + '%';
        }
      }
    }
  }

  onSelectChange(event,key) {
    let selectedDoc = this.state.documentFiletypeList.filter(doc => doc.value === event);
    const fileObj = this.state.passFile.map(file => {

      if(file.key === key){
        file.selectedDoc = selectedDoc[0];
        file.isSelected = true;
      }
      return file;
    });

    this.props.isDisabledHandler(fileObj);
  
    this.setState({
      reverseFileList: fileObj,
    });
  }

  displayFileList() {
    let tempArray = [...this.state.passFile];
    let reverseFileList = tempArray.reverse();

    return (
      reverseFileList.map((file, key) => {
        file.key=key;
        let widths = 0;
        let ele = document.getElementById(file.file.name);
        if (ele != null) {
          widths = ele.style.width;
        }
        return (
          <PassFiles
            files={file}
            keys={key}
            width={widths}
            deleteFile={this.deleteFile}
            fileUploaded={this.props.fileUploaded}
            dataList={(['EMD', 'MXP'].includes(this.props.acquirerCode) && file.file.type === 'application/pdf') ? this.state.documentFiletypeList : this.state.documentFiletypeList.filter(e => e.id !== 16)}
            onSelectChange={this.onSelectChange}
            selectedDocType={file.selectedDoc}
            promptText="Select"
          />
        );

      }
      ));
  }

  displayFailFileList() {
    return (this.state.failedFile.map(failFile => {
      return (<FailedFiles
        failedFile={failFile}
      />)
    })
    )
  }
  deleteFile = (index) => {
    let tempArray = [...this.state.passFile];
    let reverseFileList = tempArray.reverse();
    let fileToDelete = reverseFileList[index];

    deleteDocument(fileToDelete.documentName)
      .then(res => {
        let remainingFiles = this.state.passFile.filter(file => {
          return file.file.name !== fileToDelete.file.name;
        })
        this.props.isDisabledHandler(remainingFiles);
        this.setState(
          {
            passFile: remainingFiles
          }, () => {
            if (this.state.fileCount === 0) {
              this.props.fileUploaded(false, this.state.passFile);
            } else {
              this.props.fileUploaded(true, this.state.passFile);
            }

          }
        )
      })

  }

  render() {
    let heights = this.state.failedFile.length * 55 + this.state.passFile.length * 55 + 200;
    return (
      <div className="action-pane-upload">
        {this.showErrorBanner()}
        <div className="content-styles" style={{ height: heights }}>
          {this.fileUploadInitialBlock}
          {
            (this.state.failedFile.length > 0) && this.displayFailFileList()
          }

          {
            (this.state.passFile.length > 0) &&
            (
              <div>
                <div className="seperator">
                  <span style={{marginRight:"250px"}}>Filename</span>
                  <span>File Labels</span>
                </div>
                <div className="seperator-line"></div>
              </div>
            )
          }
          {
            (this.state.passFile.length > 0) && this.displayFileList()
          }
        </div>
      </div>
    );
  }
}


UploadDocuments.propTypes = {
  uploadFileList: PropTypes.array,
}



UploadDocuments.defaultProps = {
  uploadFileList: [],
}

export default UploadDocuments;
